<div class="rfq-list-dropdown__wrapper">
  <div class="lum-label">{{ label }}</div>
  <input
    [type]="type"
    [value]="displayValue"
    [placeholder]="placeholder"
    matInput
    class="lum-input"
    (input)="onSearchKeywordChange($event)"
    [matAutocomplete]="auto"
    #autocompleteInput
  />
  <mat-autocomplete
    panelWidth="auto"
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="onSelectOption($event)"
  >
    <ng-container *ngIf="!(loading$ | async) || false; else loader">
      <mat-option *ngFor="let rfq of rfqs" [value]="rfq">
        {{ rfq?.product_name }} [{{ rfq?.sku }}]
      </mat-option>
    </ng-container>
    <ng-template #loader>
      <mat-option>
        <div class="flex gap-4">
          <mat-progress-spinner
            class="progress-spinner mt-3"
            diameter="24"
            mode="indeterminate"
          ></mat-progress-spinner>
          <small>Loading...</small>
        </div>
      </mat-option>
    </ng-template>
  </mat-autocomplete>
</div>
